/**
  Welcome, welcome to the font awesome import script!
  Register the name of the icon below prefixed with the import name tag.
  If you need bell from Font Awesome Solid (FAS) it becomes fasBell,
  chevron-up becomes fasChevronUp. Notice that styles need to be aliased
  to avoid conflicts between imports.
*/
import {library} from '@fortawesome/fontawesome-svg-core'

// Custom
/**
  Troubleshooting: icon is invisible/not there. make sure the name you ask forEach
  exists. E.g. naming it eelectrical and asking for electrical. Also remember to use
  the iconName, not the name listed her. Although if you remove the prefix and turn
  it into kebab-case it should match E.g. customConnectionConnectedInSync becomes
  connection-connected-in-sync.
*/
import {
  stations as customStations,
  programs as customPrograms,
  sensors as customSensors,
  sensorsAlt as customSensorsAlt,
  station as customStation,
  electrical as customElectrical,
  controllerMode as customControllerMode,
  connectionConnecting as customConnectionConnecting,
  connectionConnected as customConnectionConnected,
  connectionFailed as customConnectionFailed,
  connectionNoConnection as customConnectionNoConnection,
  connectionConnectedNotInSync as customConnectionConnectedNotInSync,
  connectionConnectedInSync as customConnectionConnectedInSync,
  syncGeneralIcon as customSyncGeneralIcon,
  syncNoChange as customSyncNoChange,
  syncRecommendedControllerToWeb as customSyncRecommendedControllerToWeb,
  syncRecommendedWebToController as customSyncRecommendedWebToController,
  syncManualInverseFromCWtoWC as customSyncManualInverseFromCWtoWC,
  syncManualInverseFromWCtoCW as customSyncManualInverseFromWCtoCW,
  selectAll as customSelectAll,
  deSelectAll as customDeSelectAll,
  syncAllFromController as customSyncAllFromController,
  syncAllFromWeb as customSyncAllFromWeb,
  timeStamp as customTimeStamp
} from '@/assets/javascript/custom-fontawesome-icons/custom-icons'

// Font Awesome Solid (FAS)
import {
  faKey as fasKey,
  faPlay as fasPlay,
  faArrowCircleRight as fasArrowCircleRight,
  faCheck as fasCheck,
  faSave as fasSave,
  faPlus as fasPlus,
  faTrash as fasTrash,
  faPause as fasPause,
  faChevronUp as fasChevronUp,
  faChevronRight as fasChevronRight,
  faChevronDown as fasChevronDown,
  faChevronLeft as fasChevronLeft,
  faChevronCircleLeft as fasChevronCircleLeft,
  faChevronCircleRight as fasChevronCircleRight,
  faCaretDown as fasCaretDown,
  faCaretUp as fasCaretUp,
  faEdit as fasEdit,
  faUpload as fasUpload,
  faArrowsAltH as fasArrowsAltH,
  faTimes as fasTimes,
  faAngleUp as fasAngleUp,
  faAngleDown as fasAngleDown,
  faBell as fasBell,
  faEnvelope as fasEnvelope,
  faWater as fasWater,
  faTint as fasTint,
  faDotCircle as fasDotCircle,
  faTasks as fasTasks,
  faTachometerAlt as fasTachometerAlt,
  faCogs as fasCogs,
  faUser as fasUser,
  faLock as fasLock,
  faExpandArrowsAlt as fasExpandArrowsAlt,
  faCompressArrowsAlt as fasCompressArrowsAlt,
  faClock as fasClock,
  faStop as fasStop,
  faSyncAlt as faSyncAlt,
  faUndoAlt as fasUndoAlt,
  faGlobe as fasGlobe,
  faInfoCircle as fasInfoCircle,
  faServer as fasServer,
  faSync as fasSync,
  faCloudRain as fasCloudRain,
  faSlash as fasSlash,
  faDatabase as fasDatabase,
  faSortAmountUp as fasSortAmountUp,
  faSortAmountDown as fasSortAmountDown,
  faCircleNotch as fasCircleNotch,
  faFileCsv as fasFileCsv
} from '@fortawesome/free-solid-svg-icons'

// Font Awesome Regular (FAR)
import {
  faCheckCircle as farCheckCircle,
  faSquare as farSquare,
  faClock as farClock,
  faTimesCircle as farTimesCircle,
  faSnowflake as farSnowflake,
  faEye as farEye
} from '@fortawesome/free-regular-svg-icons'

library.add(
  // Custom
  customStations,
  customPrograms,
  customSensors,
  customSensorsAlt,
  customStation,
  customElectrical,
  customControllerMode,
  customConnectionConnecting,
  customConnectionConnected,
  customConnectionFailed,
  customConnectionNoConnection,
  customConnectionConnectedNotInSync,
  customConnectionConnectedInSync,
  customSyncGeneralIcon,
  customSyncNoChange,
  customSyncRecommendedControllerToWeb,
  customSyncRecommendedWebToController,
  customSyncManualInverseFromCWtoWC,
  customSyncManualInverseFromWCtoCW,
  customSelectAll,
  customDeSelectAll,
  customSyncAllFromController,
  customSyncAllFromWeb,
  customTimeStamp,
  // Font Awesome Solid (FAS)
  fasKey,
  fasPlay,
  fasArrowCircleRight,
  fasCheck,
  fasSave,
  fasPause,
  fasPlus,
  fasTrash,
  fasChevronUp,
  fasChevronRight,
  fasChevronDown,
  fasChevronLeft,
  fasChevronCircleLeft,
  fasChevronCircleRight,
  fasCaretDown,
  fasCaretUp,
  fasEdit,
  fasUpload,
  fasArrowsAltH,
  fasTimes,
  fasAngleUp,
  fasAngleDown,
  fasBell,
  fasEnvelope,
  fasWater,
  fasTint,
  fasDotCircle,
  fasTasks,
  fasTachometerAlt,
  fasCogs,
  fasUser,
  fasLock,
  fasExpandArrowsAlt,
  fasCompressArrowsAlt,
  fasClock,
  fasStop,
  fasUndoAlt,
  faSyncAlt,
  fasGlobe,
  fasServer,
  fasCloudRain,
  fasSync,
  fasSlash,
  fasDatabase,
  fasSortAmountUp,
  fasSortAmountDown,
  fasCircleNotch,
  fasFileCsv,
  // Font Awesome Regular (FAR)
  farCheckCircle,
  farSquare,
  farClock,
  farTimesCircle,
  farSnowflake,
  farEye,
  fasInfoCircle
)

// That's it! :)
